function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_31001",
  "data-name": "Group 31001"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5360",
  "data-name": "Rectangle 5360",
  width: 24,
  height: 24,
  fill: "none"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5361",
  "data-name": "Rectangle 5361",
  width: 24,
  height: 24,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_31004",
  "data-name": "Group 31004"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_31003",
  "data-name": "Group 31003"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_31002",
  "data-name": "Group 31002"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_60653",
  "data-name": "Path 60653",
  d: "M15.05,12.81,6.56,4.32a1,1,0,0,0-1.41,0L2.32,7.15a1,1,0,0,0,0,1.41l8.49,8.49a1,1,0,0,0,1.41,0l2.83-2.83A1,1,0,0,0,15.05,12.81Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60654",
  "data-name": "Path 60654",
  d: "M14.34,17.76l3.53,3.53a1.008,1.008,0,0,0,1.42,0h0a1.008,1.008,0,0,0,0-1.42l-3.53-3.53Z"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3209",
  "data-name": "Ellipse 3209",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(15 2)"
})));

function SvgSportsCricket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sports_cricket_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsCricket);
export default __webpack_public_path__ + "static/media/sports_cricket.7fafbbb4.svg";
export { ForwardRef as ReactComponent };